import { ForgotPasswordForm } from "../components";

export function ForgetPasswordPageContent() {
  return (
    <>
      <ForgotPasswordForm />
    </>
  );
}
